import React from "react";
import { Popconfirm, Switch } from "antd";
import { EntityStatus } from "../../Constants/Constants";

export const StatusSwitch = (onStatusChange) => (status, record) =>
  (
    <Popconfirm
      okText="Yes"
      cancelText="No"
      title="Are you sure want to change status?"
      onConfirm={() => onStatusChange(record, status !== EntityStatus.ACTIVE)}
    >
      <Switch size="small" checked={status === EntityStatus.ACTIVE} />
    </Popconfirm>
  );
